import { gettext } from '@eventbrite/i18n';
import { TaxpayerMissingInformation } from './types';

const TITLE_PAYOUTS_FROZEN = gettext('Your payouts are frozen');
const FILL_OUT_TAX_INFORMATION = gettext('Fill out tax information');

export const MAKE_SURE_GET_PAID = gettext('Make sure you get paid');
export const SET_YOUR_ACCOUNT = gettext(
    'Finish setting up your account to receive funds for your events.',
);
export const ADD_FINANCIAL_INFO = gettext('Add financial information');
export const ADD_FINANCIAL_INFO_TO_GET_PAID = gettext(
    'Add your financial information to receive funds from your event',
);
export const ADD_BANK_INFO_TO_GET_PAID = gettext(
    'Set your bank account to receive funds from your event',
);
export const ADD_BANK_ACCOUNT = gettext('Add a bank account');
export const COMPLETE_TAX_PAYER_INFORMATION = gettext(
    'Complete taxpayer information',
);
export const FINANCE_SETTINGS = 'finance-settings';
export const BANK_ACCOUNTS = 'bank-accounts';
export const ORGANIZATIONS = 'organizations';
export const TAXPAYER_INFO = 'taxpayer-info';

export const LOCALLY_STORED_TAXPAYER_REQUEST_STATUS_KEY =
    'locally_stored_taxpayer_request_status';

export const DOCUMENT_REQUEST_STATUS_FULFILLED = 'fulfilled';

export const TAXPAYER_SUMMARY_STATUS: {
    [index: string]: TaxpayerMissingInformation;
} = {
    none: {
        type: 'none',
        modalNotification: false,
        tooltipNotification: false,
        message: {
            title: '',
            subTitle: '',
            titleTooltip: '',
            subTitleTooltip: '',
            buttonText: '',
            buttonLink: '',
        },
    },
    fulfilled: {
        type: 'fulfilled',
        blockNew: false,
        blockEdit: false,
        tooltipNotification: false,
        modalNotification: false,
    },
    wanted: {
        type: 'wanted',
        modalNotification: true,
        tooltipNotification: false,
        message: {
            title: gettext('Complete your taxpayer information'),
            subTitle: gettext(
                'Add your tax information before your sales reach $600 total to avoid delays with your event payouts. US tax law requires us to collect your information because you host paid events.',
            ),
            titleTooltip: '',
            subTitleTooltip: '',
            buttonText: FILL_OUT_TAX_INFORMATION,
            buttonLink: '/organizations/taxpayer-information',
        },
    },
    needed: {
        type: 'needed',
        modalNotification: true,
        tooltipNotification: true,
        message: {
            title: gettext('Add taxpayer information to avoid payout delays'),
            subTitle: gettext(
                'Add your tax information or your payouts may be delayed. US tax law requires us to collect your information because you have at least $600 total in sales.',
            ),
            titleTooltip: '',
            subTitleTooltip: '',
            buttonText: FILL_OUT_TAX_INFORMATION,
            buttonLink: '/organizations/taxpayer-information',
        },
    },
    mismatched: {
        type: 'mismatched',
        modalNotification: true,
        tooltipNotification: true,
        message: {
            title: TITLE_PAYOUTS_FROZEN,
            subTitle: {
                __html: gettext(
                    "According to the IRS, your taxpayer information doesn't match their records. Please update your:<br><ul><li>Name</li><li>identification number</li></ul>You won't receive a payout until your information is updated.",
                ),
            },
            titleTooltip: TITLE_PAYOUTS_FROZEN,
            subTitleTooltip: gettext(
                "Your tax information doesn't match IRS records. Update your information to receive your payouts.",
            ),
            buttonText: gettext('Update Taxpayer information'),
            buttonLink: '/organizations/taxpayer-information',
        },
    },
    locked: {
        type: 'locked',
        modalNotification: true,
        tooltipNotification: true,
        message: {
            title: gettext('Contact payment ops to receive your payouts'),
            subTitle: gettext(
                "According to the IRS, your taxpayer information doesn't match their records for the second time in 3 years. You won't receive a payout until your information is updated correctly. Contact paymentsteam@eventbrite.com to update your information.",
            ),
            titleTooltip: TITLE_PAYOUTS_FROZEN,
            subTitleTooltip: gettext(
                "Your tax information doesn't match IRS records. Contact paymentsteam@eventbrite.com to update your information and resume your payouts.",
            ),
            buttonText: gettext('Contact us'),
            buttonLink: 'mailto:paymentsteam@eventbrite.com',
        },
    },
};
